/**
 * @file
 * Pluxee accordion script.
 */

(function ($, once) {

  'use strict';

  Drupal.behaviors.pluxeeAccordion = {

    attach: function (context, settings) {
      let $responses = $('.faq-row .faq-question');

      $(once('accordion-click', $responses)).on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        let $expanded = ($this.find("[role='button']").attr("aria-expanded") === "true");

        $responses.not(this).siblings('.faq-response').hide();
        $responses.not(this).find("[role='button']").attr("aria-expanded", "false");

        $this.siblings('.faq-response').slideToggle();
        $this.find("[role='button']").attr("aria-expanded", !$expanded);

        $("html, body").animate({ scrollTop: $this.offset().top - 90 }, "slow");
      });

      $(once('accordion-focus', $responses.find("[role='button']"))).on("focus", function (e) {
        let $this = $(this);

        $(once('accordion-keydown', $this)).on("keydown", function (e) {
            if ((e.which === 32 || e.which === 13)) {
              e.preventDefault();
              $this.parent().click();
            }
        });
      });
    }
  };
})(jQuery, once);
